/**
 * Rocker - on or off, as a plate with a lamp (the modes work's switch: a
 * `role="switch"` button, lit while on, so on and off differ by more than
 * colour).
 *
 * @param {object} props
 * @param {string} props.label
 * @param {boolean} props.on
 * @param {() => void} props.onToggle
 * @param {string} [props.testId]
 */
import styles from '../../styles/Rocker.module.css';

export default function Rocker({ label, on, onToggle, testId }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      className={styles.rocker}
      data-testid={testId}
      onClick={onToggle}
    >
      <span className={styles.lamp} aria-hidden="true" />
      {label}
    </button>
  );
}
